import * as React from 'react';
import { Link } from 'gatsby';
// import { StaticImage } from 'gatsby-plugin-image';

import Layout from '../components/Layout';
import SEO from '../components/SEO';
import TabHeaderBlock from '../components/TabHeaderBlock';
import { WhiteBlock } from '../styles/WhiteBlock';

const Intergration = () => (
  <Layout>
    <SEO title="Home" />
    <div className="db-area-main">
      <div className="db-container">
        <a href="#!" className="db-back-link button-chevron-left">
          <img src="/img/chevron-left.svg" alt="chevron" /> Back to the
          dashboard
        </a>
        <h1 className="db-heading">
          Dribbble Workspace{' '}
          <img
            src="/img/chevron-down.svg"
            alt="chevron"
            style={{ width: 23, opacity: 0.4 }}
          />
        </h1>

        <TabHeaderBlock />

        <div className="db-tab-content-block">
          <h2 className="db-heading">All Integration</h2>
          <div className="flex-row">
            <div className="col col-3">
              <WhiteBlock className="mb-30">
                <div className="single-integration-block">
                  <div className="flex-row no-margin align-items-center">
                    <div className="integration-logo">
                      <img src="/img/hubspot-crm.png" alt="hubspot" />
                    </div>
                    <div className="text-right flex-1">
                      <Link
                        to="/connect-integration/"
                        className="button light-blue-button">
                        Connect
                      </Link>
                    </div>
                  </div>

                  <h4>Hubspot CRM</h4>
                  <p>
                    Share makestories projects &amp; add it on your stories
                    everywhere 🙌🏻
                  </p>
                </div>
              </WhiteBlock>
            </div>
            <div className="col col-3">
              <WhiteBlock className="mb-30">
                <div className="single-integration-block">
                  <div className="flex-row no-margin align-items-center">
                    <div className="integration-logo">
                      <img src="/img/google-sheets.png" alt="google-sheet" />
                    </div>
                    <div className="text-right flex-1">
                      <div className="success-text">
                        <img src="/img/green-check.svg" alt="" /> Connected
                      </div>
                    </div>
                  </div>

                  <h4>Google Sheet</h4>
                  <p>
                    Share makestories projects &amp; add it on your stories
                    everywhere 🙌🏻
                  </p>
                </div>
              </WhiteBlock>
            </div>
            <div className="col col-3">
              <WhiteBlock className="mb-30">
                <div className="single-integration-block">
                  <div className="flex-row no-margin align-items-center">
                    <div className="integration-logo">
                      <img src="/img/pipedrive.png" alt="pipedrive" />
                    </div>
                    <div className="text-right flex-1">
                      <Link
                        to="/connect-integration/"
                        className="button light-blue-button">
                        Connect
                      </Link>
                    </div>
                  </div>

                  <h4>Pipedrive</h4>
                  <p>
                    Share makestories projects &amp; add it on your stories
                    everywhere 🙌🏻
                  </p>
                </div>
              </WhiteBlock>
            </div>
            <div className="col col-3">
              <WhiteBlock className="mb-30">
                <div className="single-integration-block">
                  <div className="flex-row no-margin align-items-center">
                    <div className="integration-logo">
                      <img src="/img/zoho-crm.png" alt="zoho" />
                    </div>
                    <div className="text-right flex-1">
                      <Link
                        to="/connect-integration/"
                        className="button light-blue-button">
                        Connect
                      </Link>
                    </div>
                  </div>

                  <h4>Zoho CRM</h4>
                  <p>
                    Share makestories projects &amp; add it on your stories
                    everywhere 🙌🏻
                  </p>
                </div>
              </WhiteBlock>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
);

export default Intergration;
